/*
  NordicVend: produktgalleriets skript (snippets/NV-GALLERY.liquid).
  Låg tidigare inline i snippeten. Som egen fil cachas den mellan sidvisningar.
  Laddas med defer från snippeten. Värden från Liquid läses från skripttaggens
  data-attribut (document.currentScript), så filen innehåller ingen Liquid.
*/
  (function () {
    'use strict';

    var root = document.currentScript.closest('[data-nv-gallery]');
    if (!root || root.dataset.nvInit) return;
    root.dataset.nvInit = 'true';

    var viewer = root.querySelector('[data-nv-viewer]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-nv-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-nv-thumb]'));
    var counter = root.querySelector('[data-nv-counter]');
    var zoomPill = root.querySelector('[data-nv-open-zoom]');
    var lightbox = root.querySelector('[data-nv-lightbox]');
    var current = parseInt(root.dataset.startIndex, 10) || 0;

    if (!viewer || !slides.length) return;

    var isDesktop = window.matchMedia('(min-width: 1000px)');
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

    /* ── Variantens bild per variant-id ── */
    var variantSlide = {};
    try { variantSlide = JSON.parse(document.currentScript.getAttribute('data-variant-slide') || '{}'); } catch (e) {}

    /* ── Bildbyte ── */
    function setActive(index, scrollViewer) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      if (index === current && scrollViewer !== 'force') return;
      current = index;

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
        if (i === index) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
        if (i === index) {
          thumb.setAttribute('aria-current', 'true');
          scrollThumbIntoView(thumb);
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
      if (neighboursReady) preloadAround(index);

      if (scrollViewer && !isDesktop.matches) {
        viewer.scrollTo({ left: index * viewer.clientWidth, behavior: scrollViewer === 'instant' ? 'auto' : (window.nvScrollBehavior ? window.nvScrollBehavior() : 'smooth') });
      }
    }

    function scrollThumbIntoView(thumb) {
      var thumbsEl = root.querySelector('[data-nv-thumbs]');
      if (!thumbsEl) return;
      if (isDesktop.matches) {
        var top = thumb.offsetTop;
        if (top < thumbsEl.scrollTop || top + thumb.offsetHeight > thumbsEl.scrollTop + thumbsEl.clientHeight) {
          thumbsEl.scrollTo({ top: top - 8, behavior: (window.nvScrollBehavior ? window.nvScrollBehavior() : 'smooth') });
        }
      } else {
        var left = thumb.offsetLeft;
        if (left < thumbsEl.scrollLeft || left + thumb.offsetWidth > thumbsEl.scrollLeft + thumbsEl.clientWidth) {
          thumbsEl.scrollTo({ left: left - 8, behavior: (window.nvScrollBehavior ? window.nvScrollBehavior() : 'smooth') });
        }
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setActive(parseInt(thumb.dataset.index, 10), true);
      });
    });

    /* Piltangenter när galleriet har fokus */
    viewer.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { setActive(current + 1, true); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { setActive(current - 1, true); e.preventDefault(); }
    });

    /* Mobil: uppdatera miniatyrer och räknare först när svepet har
       stannat. Att räkna om på varje scroll-händelse gav fladder
       (1, 2, 1, 2) när snappen studsar eller när en mjuk scroll från
       ett miniatyrklick passerar startläget. */
    function settledIndex(el) {
      return Math.round(el.scrollLeft / el.clientWidth);
    }
    var viewerSettleTimer = null;
    function onViewerSettled() {
      viewerSettleTimer = null;
      if (isDesktop.matches) return;
      var index = settledIndex(viewer);
      if (index !== current) setActive(index, false);
    }
    viewer.addEventListener('scroll', function () {
      if (isDesktop.matches) return;
      if (viewerSettleTimer) clearTimeout(viewerSettleTimer);
      viewerSettleTimer = setTimeout(onViewerSettled, 120);
    }, { passive: true });
    if ('onscrollend' in window) {
      viewer.addEventListener('scrollend', function () {
        if (viewerSettleTimer) clearTimeout(viewerSettleTimer);
        onViewerSettled();
      });
    }

    /* Ställ startläget på mobil utan animation */
    if (!isDesktop.matches && current > 0) {
      viewer.scrollLeft = current * viewer.clientWidth;
    }

    /* Efterladda bara bilden före och efter den som visas, när sidan är klar
       och sedan vid varje bildbyte. Övriga bilder laddas när de behövs. */
    var neighboursReady = false;
    function preloadAround(index) {
      [index - 1, index + 1].forEach(function (i) {
        var slide = slides[i];
        if (!slide) return;
        var img = slide.querySelector('img[loading="lazy"]');
        if (img) img.loading = 'eager';
      });
    }
    window.addEventListener('load', function () {
      var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 1500); };
      idle(function () {
        neighboursReady = true;
        preloadAround(current);
      });
    });
    function firstInteraction() {
      neighboursReady = true;
      preloadAround(current);
    }
    viewer.addEventListener('pointerdown', firstInteraction, { once: true, passive: true });
    viewer.addEventListener('touchstart', firstInteraction, { once: true, passive: true });
    viewer.addEventListener('focusin', firstInteraction, { once: true });

    /* ── Variantbyte: händelsen nv:variant från variantvakten i CUSTOM-PRICE ──
       Ingen timer. Vid start läses adressen (eller variantfältet) en gång,
       och finns ingen vakt på sidan följer galleriet bakåt och framåt. */
    var lastVariant = null;
    function applyVariantId(id) {
      id = id ? String(id) : '';
      if (!id || id === lastVariant) return;
      lastVariant = id;
      if (variantSlide[id] !== undefined) setActive(variantSlide[id], true);
    }
    function readVariantId() {
      var w = window.__nvVariantWatch;
      if (w && w.current && w.current.id) return String(w.current.id);
      var id = new URLSearchParams(window.location.search).get('variant');
      var input = document.querySelector('[data-variants]');
      if (!id && input) id = input.value;
      return id || '';
    }
    // Rea-märket visas bara när vald variant är nedsatt
    var saleBadge = root.querySelector('[data-nv-gallery-badge]');
    function applySaleBadge(v) {
      if (!saleBadge || !v) return;
      saleBadge.hidden = !(v.compare_at_price && v.compare_at_price > v.price);
    }
    if (saleBadge) {
      document.addEventListener('nv:variant', function (e) {
        applySaleBadge(e.detail && e.detail.variant);
      });
      if (window.__nvVariantWatch) applySaleBadge(window.__nvVariantWatch.current);
    }

    if (Object.keys(variantSlide).length) {
      document.addEventListener('nv:variant', function (e) {
        var v = e.detail && e.detail.variant;
        if (v && v.id) applyVariantId(v.id);
      });
      window.addEventListener('popstate', function () {
        if (!window.__nvVariantWatch) applyVariantId(readVariantId());
      });
      applyVariantId(readVariantId());
    }

    /* ── Hover-zoom på dator ── */
    var zoomPanes = {};
    function setupHoverZoom(slide) {
      if (!isDesktop.matches || !canHover.matches) return;
      var img = slide.querySelector('.nv-gallery-img');
      if (!img) return;
      var natural = parseInt(slide.dataset.naturalWidth, 10) || 0;
      if (natural < slide.clientWidth * 1.3) return;

      var index = slide.dataset.index;
      var pane = zoomPanes[index];
      if (!pane) {
        pane = document.createElement('div');
        pane.className = 'nv-gallery-zoom-pane';
        pane.setAttribute('aria-hidden', 'true');
        slide.appendChild(pane);
        zoomPanes[index] = pane;

        var loader = new Image();
        loader.onload = function () {
          pane.dataset.ready = 'true';
          pane.dataset.w = loader.naturalWidth;
          pane.dataset.h = loader.naturalHeight;
          pane.style.backgroundImage = 'url("' + slide.dataset.zoomSrc + '")';
          viewer.classList.add('nv-hover-zoom-ready');
          if (slide.matches(':hover')) pane.classList.add('is-visible');
        };
        loader.src = slide.dataset.zoomSrc;
      } else if (pane.dataset.ready) {
        pane.classList.add('is-visible');
      }
    }
    function moveHoverZoom(slide, e) {
      var pane = zoomPanes[slide.dataset.index];
      if (!pane || !pane.dataset.ready) return;
      var rect = slide.getBoundingClientRect();
      var x = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
      var y = Math.max(0, Math.min(1, (e.clientY - rect.top) / rect.height));
      var w = parseInt(pane.dataset.w, 10);
      var h = parseInt(pane.dataset.h, 10);
      var scale = Math.max(1.6, Math.min(2.4, w / rect.width));
      pane.style.backgroundSize = (w * scale / (w / rect.width)) + 'px ' + (h * scale / (w / rect.width)) + 'px';
      pane.style.backgroundPosition = (x * 100) + '% ' + (y * 100) + '%';
      pane.classList.add('is-visible');
    }
    slides.forEach(function (slide) {
      slide.addEventListener('mouseenter', function () { setupHoverZoom(slide); });
      slide.addEventListener('mousemove', function (e) {
        if (isDesktop.matches && canHover.matches) moveHoverZoom(slide, e);
      });
      slide.addEventListener('mouseleave', function () {
        var pane = zoomPanes[slide.dataset.index];
        if (pane) pane.classList.remove('is-visible');
      });
    });

    /* ── Zoomvy (lightbox) ── */
    if (!lightbox) return;

    /* Flytta zoomvyn till body: .product-left är sticky och skapar en
       egen stapel-kontext, så ett position:fixed-element som ligger kvar
       där hamnar under köpkolumnens widgets oavsett z-index. */
    NVPanel.toBody(lightbox);

    var strip = lightbox.querySelector('[data-nv-lb-strip]');
    var lbSlides = Array.prototype.slice.call(lightbox.querySelectorAll('[data-nv-lb-slide]'));
    var lbThumbs = Array.prototype.slice.call(lightbox.querySelectorAll('[data-nv-lb-thumb]'));
    var lbThumbsEl = lightbox.querySelector('[data-nv-lb-thumbs]');
    var lbCounter = lightbox.querySelector('[data-nv-lb-counter]');
    var lbClose = lightbox.querySelector('[data-nv-lb-close]');
    var lbPrev = lightbox.querySelector('[data-nv-lb-prev]');
    var lbNext = lightbox.querySelector('[data-nv-lb-next]');
    var lbCurrent = 0;
    var lbOpener = null;
    var lbHideTimer = null;
    var zoom = { scale: 1, x: 0, y: 0 };
    var pointers = {};
    var pinchStart = null;
    var lastTap = 0;

    function lbLoad(index) {
      [index - 1, index, index + 1].forEach(function (i) {
        var slide = lbSlides[i];
        if (!slide) return;
        var img = slide.querySelector('img[data-src]');
        if (img && !img.src) img.src = img.dataset.src;
      });
    }

    function lbSetCurrent(index, scroll) {
      index = Math.max(0, Math.min(lbSlides.length - 1, index));
      if (index !== lbCurrent) resetZoom();
      lbCurrent = index;
      if (lbCounter) lbCounter.textContent = (index + 1) + ' / ' + lbSlides.length;
      lbThumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
        if (i === index) {
          thumb.setAttribute('aria-current', 'true');
          if (lbThumbsEl) {
            var left = thumb.offsetLeft;
            if (left < lbThumbsEl.scrollLeft || left + thumb.offsetWidth > lbThumbsEl.scrollLeft + lbThumbsEl.clientWidth) {
              lbThumbsEl.scrollTo({ left: left - lbThumbsEl.clientWidth / 2 + thumb.offsetWidth / 2, behavior: (window.nvScrollBehavior ? window.nvScrollBehavior() : 'smooth') });
            }
          }
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
      lbLoad(index);
      if (scroll) {
        strip.scrollTo({ left: index * strip.clientWidth, behavior: scroll === 'instant' ? 'auto' : (window.nvScrollBehavior ? window.nvScrollBehavior() : 'smooth') });
      }
    }

    function activeImg() {
      return lbSlides[lbCurrent] ? lbSlides[lbCurrent].querySelector('img') : null;
    }

    function applyZoom(animate) {
      var img = activeImg();
      if (!img) return;
      img.style.transition = animate ? 'transform 0.2s ease' : 'none';
      img.style.transform = 'translate(' + zoom.x + 'px, ' + zoom.y + 'px) scale(' + zoom.scale + ')';
      img.classList.toggle('is-zoomed', zoom.scale > 1);
      lightbox.classList.toggle('is-zoomed', zoom.scale > 1);
    }

    function resetZoom() {
      var img = activeImg();
      zoom = { scale: 1, x: 0, y: 0 };
      if (img) {
        img.style.transition = 'none';
        img.style.transform = '';
        img.classList.remove('is-zoomed');
      }
      lightbox.classList.remove('is-zoomed');
    }

    function clampZoom() {
      var img = activeImg();
      if (!img) return;
      var slide = lbSlides[lbCurrent];
      var iw = img.clientWidth * zoom.scale;
      var ih = img.clientHeight * zoom.scale;
      var maxX = Math.max(0, (iw - slide.clientWidth) / 2 + slide.clientWidth * 0.1);
      var maxY = Math.max(0, (ih - slide.clientHeight) / 2 + slide.clientHeight * 0.1);
      var baseX = (img.clientWidth * (zoom.scale - 1)) / 2;
      var baseY = (img.clientHeight * (zoom.scale - 1)) / 2;
      zoom.x = Math.max(-baseX - maxX, Math.min(-baseX + maxX, zoom.x));
      zoom.y = Math.max(-baseY - maxY, Math.min(-baseY + maxY, zoom.y));
    }

    function toggleZoomAt(clientX, clientY) {
      var img = activeImg();
      if (!img) return;
      if (zoom.scale > 1) {
        resetZoom();
        applyZoom(true);
        return;
      }
      var rect = img.getBoundingClientRect();
      var scale = 2.5;
      var px = clientX - rect.left;
      var py = clientY - rect.top;
      zoom.scale = scale;
      zoom.x = -px * (scale - 1);
      zoom.y = -py * (scale - 1);
      clampZoom();
      applyZoom(true);
    }

    function openLightbox(index) {
      if (lbHideTimer) { window.clearTimeout(lbHideTimer); lbHideTimer = null; }
      lbOpener = document.activeElement;
      lightbox.hidden = false;
      document.body.classList.add('nv-zoom-open');
      lbSetCurrent(index, false);
      strip.scrollLeft = index * strip.clientWidth;
      requestAnimationFrame(function () {
        lightbox.classList.add('is-open');
      });
      lbClose.focus();
    }

    function closeLightbox() {
      resetZoom();
      lightbox.classList.remove('is-open');
      document.body.classList.remove('nv-zoom-open');
      if (lbHideTimer) window.clearTimeout(lbHideTimer);
      lbHideTimer = window.setTimeout(function () { lbHideTimer = null; lightbox.hidden = true; }, 200);
      if (lbOpener && lbOpener.focus) lbOpener.focus();
    }

    viewer.addEventListener('click', function (e) {
      if (e.target.closest('[data-nv-slide]')) openLightbox(current);
    });
    if (zoomPill) {
      zoomPill.addEventListener('click', function () { openLightbox(current); });
    }
    lbClose.addEventListener('click', closeLightbox);
    if (lbPrev) lbPrev.addEventListener('click', function () { lbSetCurrent(lbCurrent - 1, true); });
    if (lbNext) lbNext.addEventListener('click', function () { lbSetCurrent(lbCurrent + 1, true); });
    lbThumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        lbSetCurrent(parseInt(thumb.dataset.index, 10), true);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') { closeLightbox(); return; }
      if (e.key === 'ArrowRight') lbSetCurrent(lbCurrent + 1, true);
      if (e.key === 'ArrowLeft') lbSetCurrent(lbCurrent - 1, true);
      if (e.key === 'Tab') {
        /* Fokusfälla i zoomvyn: stäng, pilarna och miniatyrerna längst ner,
           i den ordningen. Knappar som inte syns (pilarna på mobil) hoppas över. */
        var focusables = [lbClose, lbPrev, lbNext].concat(lbThumbs).filter(function (el) {
          return el && !el.disabled && el.getClientRects().length > 0;
        });
        if (!focusables.length) { e.preventDefault(); return; }
        var i = focusables.indexOf(document.activeElement);
        var next = e.shiftKey ? i - 1 : i + 1;
        if (next < 0) next = focusables.length - 1;
        if (next >= focusables.length) next = 0;
        focusables[next].focus();
        e.preventDefault();
      }
    });

    /* Samma stanna-först-logik som för huvudbilden */
    var lbSettleTimer = null;
    function onStripSettled() {
      lbSettleTimer = null;
      if (lightbox.hidden || lightbox.classList.contains('is-zoomed')) return;
      var index = settledIndex(strip);
      if (index !== lbCurrent) lbSetCurrent(index, false);
    }
    strip.addEventListener('scroll', function () {
      if (lbSettleTimer) clearTimeout(lbSettleTimer);
      lbSettleTimer = setTimeout(onStripSettled, 120);
    }, { passive: true });
    if ('onscrollend' in window) {
      strip.addEventListener('scrollend', function () {
        if (lbSettleTimer) clearTimeout(lbSettleTimer);
        onStripSettled();
      });
    }

    /* Nyp-zoom, panorering och dubbeltryck i zoomvyn */
    strip.addEventListener('pointerdown', function (e) {
      if (e.target.tagName !== 'IMG') return;
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pointers);
      if (ids.length === 2) {
        var a = pointers[ids[0]], b = pointers[ids[1]];
        pinchStart = {
          dist: Math.hypot(a.x - b.x, a.y - b.y),
          scale: zoom.scale,
          x: zoom.x,
          y: zoom.y,
          cx: (a.x + b.x) / 2,
          cy: (a.y + b.y) / 2
        };
      } else if (ids.length === 1 && zoom.scale > 1) {
        e.target.setPointerCapture(e.pointerId);
      }
    });
    strip.addEventListener('pointermove', function (e) {
      if (!pointers[e.pointerId]) return;
      var prev = pointers[e.pointerId];
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pointers);
      if (ids.length === 2 && pinchStart) {
        var a = pointers[ids[0]], b = pointers[ids[1]];
        var dist = Math.hypot(a.x - b.x, a.y - b.y);
        var next = Math.max(1, Math.min(4, pinchStart.scale * (dist / pinchStart.dist)));
        var ratio = next / pinchStart.scale;
        zoom.scale = next;
        zoom.x = pinchStart.cx - ratio * (pinchStart.cx - pinchStart.x);
        zoom.y = pinchStart.cy - ratio * (pinchStart.cy - pinchStart.y);
        if (zoom.scale <= 1.02) { zoom = { scale: 1, x: 0, y: 0 }; }
        clampZoom();
        applyZoom(false);
        e.preventDefault();
      } else if (ids.length === 1 && zoom.scale > 1) {
        zoom.x += e.clientX - prev.x;
        zoom.y += e.clientY - prev.y;
        clampZoom();
        applyZoom(false);
        e.preventDefault();
      }
    });
    function pointerEnd(e) {
      delete pointers[e.pointerId];
      if (Object.keys(pointers).length < 2) pinchStart = null;
    }
    strip.addEventListener('pointerup', pointerEnd);
    strip.addEventListener('pointercancel', pointerEnd);

    strip.addEventListener('click', function (e) {
      if (e.target.tagName !== 'IMG') return;
      var now = Date.now();
      if (canHover.matches) {
        toggleZoomAt(e.clientX, e.clientY);
      } else if (now - lastTap < 350) {
        toggleZoomAt(e.clientX, e.clientY);
        lastTap = 0;
      } else {
        lastTap = now;
      }
    });
  })();
